import Promise from 'bluebird'
import request from 'superagent'
import Auth from '../services/auth'
import api from '../services/api'
import config from 'config'
import store from 'state/index.js'
import { forecastTypes } from './constants'

// Actions are payloads of information that send data from your application to your store. 
// They are the only source of information for the store.

import {
GET_OUTPUT,
GET_OUTPUT_FAIL,
GET_OUTPUT_SUCCESS,
GET_RCLOOKUPDATA,
GET_RCLOOKUPDATA_FAIL,
GET_RCLOOKUPDATA_SUCCESS,
GET_RC_USER_DATA,
GET_RC_USER_DATA_FAIL,
GET_RC_USER_DATA_SUCCESS,
SET_USER_RC_DATA,
SET_USER_RC_DATA_FAIL,
SET_USER_RC_DATA_SUCCESS,
VALIDATE,
CHANGE_INPUT,
RESET_SAVE_SUCCESS,
} from './action-types.js'

const API_URL_MAP = {
	'retirement-calc.prod.miopartners.com': 'https://bsa.prod.miopartners.com/backend/retirement_calculator/',
	'retirement-calc.acp.miopartners.com': 'https://bsa.preprod.miopartners.com/backend/retirement_calculator/',
}

const MIO_BSA_ACCESS_TOKEN_KEY = 'mioBSAAccessToken';
const SUB_CLIENT_KEY = 'subClient';

function getApiUrl() {
  return API_URL_MAP[window.location.hostname];
}

function logApiResult(err, res) {
  if (process.env.NODE_ENV === 'production') return
  const url = res.req.url
  if (err) {
    console.groupCollapsed(`%c${url}%c - ${err}`, 'color: #b70a0a; font-weight: bold;', 'font-weight:normal; color:#444;')
    console.log(res)
  } else {
    console.groupCollapsed(`%c${url}`, 'color: #246cca; font-weight: bold;')
    console.log(res)
  }
  console.groupEnd()
}

api.post = ({ url = false, data = {}, isPrivate = true, contentType = 'application/x-www-form-urlencoded' }) => {
  const currentUrl = new URL(window.location.href);
  const subClient = currentUrl.searchParams.get(SUB_CLIENT_KEY);
  const mioAccessToken = currentUrl.searchParams.get(MIO_BSA_ACCESS_TOKEN_KEY);
  const bearerToken = `Bearer ${mioAccessToken}`;
  return new Promise((resolve, reject)=>{
    request
      .post(url)
      .send(data)
      .type('form')
      .set(`Authorization`, bearerToken)
      .set('Content-Type', contentType)
	  .set('subClient', subClient)
      .end(function(err, res){
        logApiResult(err, res)
        resolve(res)
      })
  })
}

api.get = ({ url = false, query = {}, isPrivate = true }) => {
  const currentUrl = new URL(window.location.href);
  const subClient = currentUrl.searchParams.get(SUB_CLIENT_KEY);
  const mioAccessToken = currentUrl.searchParams.get(MIO_BSA_ACCESS_TOKEN_KEY);
  const bearerToken = `Bearer ${mioAccessToken}`;
  return new Promise((resolve, reject)=>{
    request
      .get(url)
      .query(query)
      .set('Accept', 'application/json')
      .set(`Authorization`, bearerToken)
	  .set('subClient', subClient)
      .end(function(err, res){
        logApiResult(err, res)
        resolve(res)
      })
    })
}

function transformChartData(chartData) {
	return chartData.map(row => ({
		totalNonTaxable: row.tot_nt,
		returnDistributions: row.ret_dist,
		totalReal: row.tot_real,
		netDistributionReal: row.net_dist_real,
		netDistribution: row.net_dist,
		age: row.age,
		totalNominal: row.tot_nom,
		returnAccumulated: row.ret_acc,
		contributionTaxable: row.cont_t,
		taxOnDistribution: row.tax_dist,
		totalTaxable: row.tot_t,
		contributionNonTaxable: row.cont_nt,
		netReturns: row.net_ret,
		totalWealth: row.tot_nom || (row.tot_t + row.tot_nt),
	}))
}

export function getOutput(input){
	return(dispatch, getState) => {

		dispatch({type: GET_OUTPUT})
		
		return api.get({
			url: `${getApiUrl()}get_results/`,
			query: input
		}).then(res => {
			const status = res.status
			if(status == 500 || status == 400){
				dispatch({
					type: GET_OUTPUT_FAIL,
					error: {
						hasError: true,
						message: "Please review your input values"
					}
				})
			} else {
				const resObj = JSON.parse(res.text)
				var chartData = transformChartData(resObj.chartData)

				// For breakdown
				const totalContributionsTaxable = chartData.reduce((sum, row) => {
					sum += row.contributionTaxable
					return sum
				}, 0)
				const totalContributionsNonTaxable = chartData.reduce((sum, row) => {
					sum += row.contributionNonTaxable
					return sum
				}, 0)

				const retirementAge = input.forecast === forecastTypes.AGE
				? resObj.answer
				: parseInt(input.retirement_age_target)

				const retirementAnnualIncome = input.forecast === forecastTypes.ANNUAL_INCOME
				? resObj.answer
				: parseFloat(input.annual_income)

				const afterTaxContributions = input.forecast === forecastTypes.AFTER_TAX
				? resObj.answer
				: parseFloat(input.contributions_at)

				const totalTaxable = chartData.find(d => d.age === retirementAge).totalTaxable
				const totalNonTaxable = chartData.find(d => d.age === retirementAge).totalNonTaxable

				dispatch({
					type: GET_OUTPUT_SUCCESS,
					totalContributionsTaxable,
					totalContributionsNonTaxable,
					retirementAge,
					retirementAnnualIncome,
					afterTaxContributions,
					totalTaxable,
					totalNonTaxable,
					forecast: input.forecast,
					chartData,
					sensitivityData: resObj.sensitivityTable || {},
					error: {
						hasError: false,
						message: ""
					}
				})
			}
		})
	}
}

export function getRCLookupData(){
	return (dispatch, getState) => {
		dispatch({type: GET_RCLOOKUPDATA})
		return api.get({
			url: `${getApiUrl()}get_lookup_data/`,
		}).then(res => {
			const resObj = JSON.parse(res.text)
			dispatch({
				type: GET_RCLOOKUPDATA_SUCCESS,
				dropdownData: resObj.data.rc_info_output
			})
			dispatch(getUserData())
		})
	}
}

export function getUserData(){
	return (dispatch, getState) => {
		dispatch({type: GET_RC_USER_DATA})
		api.get({
			url: `${getApiUrl()}get_retirement_calculator/`,
		}).then(res => {
			const resObj = JSON.parse(res.text)
			var userData = {}
			if(resObj.data){
				userData = resObj.data.rc_info_output[0]
			}else{
				userData = resObj
			}
			dispatch({
				type: GET_RC_USER_DATA_SUCCESS,
				userData: userData
			})
		})
	}
}

export function setUserRcData(input){
	return (dispatch, getState) => {
		dispatch({type: SET_USER_RC_DATA})
		api.post({ 
			url: `${getApiUrl()}save/`,
			data: {
				annual_income: input['annual_income'],
				retirement_age_target: input['retirement_age_target'],
				forecast: input['forecast'],
				contributions_at: input['contributions_at'],
				inflation: input['inflation'],
				current_age: input['current_age'],
				life_expectancy: input['life_expectancy'],
				leftover_assets_real: input['leftover_assets_real'],
				portfolio_return_accu: input['portfolio_return_accu'],
				inv_wealth_at: input['inv_wealth_at'],
				cont_growth_at: input['cont_growth_at'],
				agg_tax_type: input['agg_tax_type'],
				agg_tax: input['agg_tax'],
				inv_wealth_pt: input['inv_wealth_pt'],
				pretax_contribution: input['pretax_contribution'],
				cont_growth_pt: input['cont_growth_pt'],
				max_bal: input['max_bal'],
				portfolio_return_dist: input['portfolio_return_dist'],
				dist_growth: input['dist_growth'],
				tax_portfolio_at: input['tax_portfolio_at'],
				tax_dist_at: input['tax_dist_at'],
				tax_portfolio_pt: input['tax_portfolio_pt'],
				tax_dist_pt: input['tax_dist_pt'],
			}
		}).then(res => {
			const status = res.status
			var res = JSON.parse(res.text)
			if(status == 500 || status == 400){
				dispatch({
					type: SET_USER_RC_DATA_FAIL,
					error: {
						hasError: true,
						message: "Error saving data."
					}
				})
			}else{
				dispatch({
					type: SET_USER_RC_DATA_SUCCESS,
					error: {
						hasError: false,
						message: ""
					},
					saveSuccess: true
				})
				setTimeout(function(){dispatch({type: RESET_SAVE_SUCCESS})}, 4000)
			}
		})
	}	
}

export function validate(uid){
	return (dispatch, getState) => {
		dispatch({
			type: VALIDATE,
			uid: uid
		})
	}
}

export function changeInput(input){
	return (dispatch, getState) => {
		dispatch({
			type: CHANGE_INPUT,
			input: input
		})
	}
}

export function raiseError(){
	return(dispatch, getState) => {
		dispatch({
			type: GET_OUTPUT_FAIL,
			error: {
				hasError: true,
				message: "Please review your input values"
			}
		})
	}
}


// WEBPACK FOOTER //
// ./state/actions.js